// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAnalytics } from 'firebase/analytics'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAbS48mvyNUGu9GpQqoc9dFhEsW0w5_hWg",
  authDomain: "testfirebase-ecomapp.firebaseapp.com",
  projectId: "testfirebase-ecomapp",
  storageBucket: "testfirebase-ecomapp.appspot.com",
  messagingSenderId: "379092265006",
  appId: "1:379092265006:web:7015835a71bbe35af1d7bf",
  measurementId: "G-81PRGFK9R6",
};

// Initialize Firebase
const FirebaseApp = initializeApp(firebaseConfig);
const analytics = getAnalytics(FirebaseApp);

export default FirebaseApp;
